// BOTÓN DE "GENERAR LINK", CON LOS TRES ESTADOS QUE IMPORTAN.
//
// El problema que resuelve: entre el toque y la ventana del link puede pasar un segundo,
// y en ese segundo no pasaba nada visible. El RRPP apretaba otra vez y salían dos links
// — y cada link generado cuenta como venta, así que el duplicado le infla la rendición y
// hay que ir a borrarlo a mano.
//
//   listo      → se puede generar.
//   generando  → gris, llenándose del color del botón, y no acepta otro toque.
//   hecho      → queda bloqueado hasta que la persona elija "Generar otro link".
//
// El bloqueo del botón es la mitad del arreglo; la otra es el guard del que llama, para
// que dos toques en el mismo instante (antes del primer render) tampoco pasen.
export default function BotonGenerarLink({ generando, hecho, disabled, onClick, texto = 'Generar QR · Link →' }) {
  const clase = 'lb-btn lb-btn--primary lb-btn--block' + (generando ? ' lb-btn--cargando' : '');
  return (
    <button className={clase} onClick={onClick} disabled={disabled || generando || hecho}>
      {generando && <span className="lb-btn__fill" />}
      <span className="lb-btn__txt">
        {generando ? 'Generando link…' : hecho ? 'Link generado ✓' : texto}
      </span>
    </button>
  );
}
